/* eslint-disable */
// @ts-nocheck

import { create } from 'zustand'

// src/stores/useCounterStore.ts
import { CompanyType } from '@/api/filesAPI'
import { User } from '@/interfaces/vehicle'

export interface Selector {
  id: number
  name: string
  type?: string
}

export interface Price {
  amount: number
  codeCurrency: string
}

export interface Cost {
  id?: number
  fixedCostCategoryId: number
  price: Price
  exchangeRate?: number
  observations?: string
}

export interface Document {
  id?: number
  name: string
  path: string
  observations?: string
}

export interface Product {
  id?: number
  uniqueCode: string
  description: string
  //entryAt: string
  //measure: string
  expirationAt: string
  //entryQuantity: number
  availableQuantity: number
  noPackages: number
  product: {
    id: number
    name: string
  }
  //variation: string
  product_cost: { codeCurrency: string; amount: number }
  product_provider: CompanyType
}

interface DataType {
  name: string
  originId: number
  countryFromId: number
  destinyId: number
  categories: number[]
  levanteNumber: string
  trackingNumber: string
  observations: string
  documents: { path: string; observations: string }[]
  listCosts: {
    costAmount: number
    costCodecurrency: string
    type?: string
  }[]
  ownerCompany?: string | number | null
  importerCompany?: string | number | null
  transporterCompany?: string | number | null
  storageCompany?: string | number | null
  logisticCompany?: string | number | null
  isRefrigered?: boolean
  isPalleted?: boolean
  code?: string | null
  sealNumber?: string | null
  temperatureRange?: string | null
  transportedBy?: string | null
  netWeight?: number | null
  numberOfPallets?: number | null
}

// 1. Define la interfaz para el estado y las acciones de tu store
interface ContainerWizzardState {
  data: DataType

  // Acciones: Son funciones que no reciben nada y no devuelven nada,
  // o que reciben argumentos y no devuelven nada.

  updateData: (data: DataType) => void
  resetData: () => void
}

// 2. Crea el store, pasando tu interfaz como un argumento genérico a `create`
const useContainerWizzardSteps = create<ContainerWizzardState>((set, get) => ({
  // Estado inicial
  data: {
    name: '',
    originId: 0,
    countryFromId: 0,
    destinyId: 0,
    categories: [],
    levanteNumber: '',
    trackingNumber: '',
    observations: '',
    documents: [],
    listCosts: [],
    ownerCompany: null,
    importerCompany: null,
    transporterCompany: null,
    storageCompany: null,
    logisticCompany: null,
    isRefrigered: false,
    isPalleted: false,
    code: null,
    sealNumber: null,
    temperatureRange: null,
    transportedBy: null,
    netWeight: null,
    numberOfPallets: null,
  },

  // Acciones (implementación de las funciones definidas en la interfaz)
  updateData: (data: DataType) => set(() => ({ data })),
  resetData: () => set(() => ({
    data: {
      name: '',
      originId: 0,
      countryFromId: 0,
      destinyId: 0,
      categories: [],
      levanteNumber: '',
      trackingNumber: '',
      observations: '',
      documents: [],
      listCosts: [],
      ownerCompany: null,
      importerCompany: null,
      transporterCompany: null,
      storageCompany: null,
      logisticCompany: null,
      isRefrigered: false,
      isPalleted: false,
      code: null,
      sealNumber: null,
      temperatureRange: null,
      transportedBy: null,
      netWeight: null,
      numberOfPallets: null,
    }
  })),
}))

export default useContainerWizzardSteps
